<template>
  <Dialog
    :visible="isOpen"
    header="Édition de projet"
    :modal="true"
    :closable="false"
    class="p-fluid test"
  >
    <div class="p-field">
      <label for="title" class="w-full">Titre</label>
      <InputText
        class="w-full"
        id="title"
        v-model.trim="editedProject.title"
        required="true"
        autofocus :class="{'p-invalid': !editedProject.title}"
      />
      <small class="p-error" v-if="!editedProject.title">Nom requis.</small>
    </div>
    <div class="p-field">
      <label for="description">Description</label>
      <Textarea
        id="title"
        v-model="editedProject.description"
        rows="5"
        cols="30"
      />
    </div>
    <div class="p-field">
      <label for="users">Administrateurs</label>
      <Chips id="description" class="p-chips-multiline" v-model="editedProject.adminsEmail"
            :allowDuplicate="false"/>
    </div>
    <div class="p-field">
      <label for="users">Participants</label>
      <Chips id="description" class="p-chips-multiline"
            v-model="editedProject.participantsEmail" :allowDuplicate="false"/>
    </div>
    <div class="p-field">
      <div class="flex gap-4">
        <label for="description">Mode examen: </label>
        <InputSwitch v-model="editedProject.hasAccessPeriod"/>
        Période d'accès
      </div>
        <div
          class="grid w-full gap-2"
          v-if="editedProject.hasAccessPeriod"
        >
          <label for="startDate" class="text-xs">Date de début : </label>
          <Calendar
            class="max-w-lg"
            v-model="editedProject.startDate"
            :min-date="new Date()"
            :numberOfMonths="2"
            dateFormat="dd/mm/yy"
            show-time
            show-icon
          />
        </div>
        <div
          class="grid w-full gap-2"
          v-if="editedProject.hasAccessPeriod"
        >
          <label for="endDate" class="text-xs">Date de fin : </label>
          <Calendar
            class="max-w-lg"
            v-model="editedProject.endDate"
            :min-date="minEndDate"
            :numberOfMonths="2"
            dateFormat="dd/mm/yy"
            show-time
            show-icon
          />
        </div>
      </div>

    <template #footer>
      <Button label="Annuler" icon="mdi-close" class="p-button-text p-button-danger" @click="hideDialog"/>
      <Button label="Sauvegarder" icon="mdi-check" class="p-button-text" @click="saveProject"/>
    </template>
  </Dialog>
</template>

<script>
import moment from "moment"

export default {
  name: "EditProjectDialog",
  data () {
    return {
      untouchedProject: undefined,
      editedProject: {
        title: '',
        description: '',
        participantsEmail: [],
        adminsEmail: [],
        hasAccessPeriod: false,
        startDate: null,
        endDate: null,
      },
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    minEndDate() {
      // Used to keep user from choosing a end date before the start date
      return moment(this.editedProject.startDate).toDate()
    }
  },
  mounted() {
    const project = this.$store.state.adminProjects.activeEntity
    if(project) {
      this.untouchedProject = { ...project }

      const emails = project.members.reduce((accEmails, user) => {
        user.pivot.is_admin === 1
          ? accEmails.admins.push(user.email)
          : accEmails.participants.push(user.email)

        return accEmails
      }, { admins: [], participants: [] })

      this.editedProject = {
        ...project,
        startDate: moment(project.start_date).toDate(),
        endDate: moment(project.end_date).toDate(),
        hasAccessPeriod: !!(project.end_date && project.start_date),
        participantsEmail: emails.participants,
        adminsEmail: emails.admins
      }
    }
  },
  methods: {
    hideDialog() {
      this.$emit("update:is-open", false);
    },
    saveProject() {
      const updatedProject = {
        ...(({ title, description, type }) => ({ title, description, type }))(this.editedProject),
        start_date: this.editedProject.hasAccessPeriod
          ? moment(this.editedProject.startDate).format('YYYY-MM-DD HH:mm:ss')
          : null,
        end_date: this.editedProject.hasAccessPeriod
          ? moment(this.editedProject.endDate).format('YYYY-MM-DD HH:mm:ss')
          : null,
      };

      this.$store.dispatch('adminProjects/update', updatedProject)

      const { membersToAdd, membersToUpdate, membersToRemove } = this.findMembersToUpdate()

      if(membersToAdd.length) {
        this.$store.dispatch('adminProjects/addMembersToActiveProject', membersToAdd)
      }
      if(membersToUpdate.length) {
        this.$store.dispatch('adminProjects/updateMembersOfActiveProject', membersToUpdate)
      }
      if(membersToRemove.length) {
        this.$store.dispatch('adminProjects/removeMembersOfActiveProject', membersToRemove)
      }

      this.hideDialog();
    },
    findMembersToUpdate() {
      const membersToUpdate = []
      const membersToAdd = []
      const membersToRemove = []

      const untouchedMembers = [ ...this.untouchedProject.members ]

      const editedMembers = []
      this.editedProject.adminsEmail.forEach(adminEmail => editedMembers.push({
        email: adminEmail,
        is_admin: 1
      }))
      this.editedProject.participantsEmail.forEach(participantEmail => editedMembers.push({
        email: participantEmail,
        is_admin: 0
      }))

      untouchedMembers.forEach((untouchedMember, index) => {
        const updatedMemberIndex = editedMembers.findIndex(editedMember => editedMember.email === untouchedMember.email)
        if (updatedMemberIndex !== -1 && untouchedMember.pivot.is_admin !== editedMembers[updatedMemberIndex].is_admin) {
          const memberToUpdate = { id: untouchedMember.id, email: untouchedMember.email, is_admin: editedMembers[updatedMemberIndex].is_admin }
          membersToUpdate.push(memberToUpdate)
          editedMembers.splice(updatedMemberIndex, 1)
          untouchedMembers.splice(index, 1)
        }
      })
      editedMembers.forEach((editedMember, index) => {
        const addedMember = untouchedMembers.find(untouchedMember => untouchedMember.email === editedMember.email)
        if (!addedMember) {
          const memberToAdd = { id: editedMember.id, email: editedMember.email, is_admin: editedMember.is_admin }
          membersToAdd.push(memberToAdd)
          editedMembers.splice(index, 1)
        }
      })
      untouchedMembers.forEach(untouchedMember => {
        const removedMember = editedMembers.find(editedMember => editedMember.email === untouchedMember.email)
        if (!removedMember) {
          const memberToRemove = { id: untouchedMember.id, email: untouchedMember.email, is_admin: untouchedMember.pivot.is_admin }
          membersToRemove.push(memberToRemove)
        }
      })

      return {
        membersToUpdate,
        membersToAdd,
        membersToRemove
      }
    },
  },
  watch: {
    "editedProject.startDate": function(newStartDate) {
      // If the new start date is later than the endDate, endDate is reset.
      if(this.editedProject.endDate && moment(newStartDate).isAfter(this.editedProject.endDate)) {
        this.editedProject.endDate = null
      }
    },
  },
}
</script>

<style scoped>

</style>
